import {
  dbReducer,
  insert,
  ReduxFind,
  removeMany,
  removeOne,
  updateOne,
} from '@weblite/persist'
import { PendingEditUpload } from '$logic/pending-edit-uploads/types'

const COLLECTION = 'pendingEditUploads'

export const pendingEditUploadsStorage = {
  delete(messageId: string) {
    removeOne(COLLECTION)(messageId)
  },

  deleteMany(uploadIds: string[]) {
    removeMany(COLLECTION)(uploadIds)
  },
  get(uploadId: string): PendingEditUpload {
    return ReduxFind(COLLECTION, { uploadId })[0]
  },

  getAll(): PendingEditUpload[] {
    return ReduxFind(COLLECTION, {})
  },

  insert(message: PendingEditUpload) {
    insert(COLLECTION)([message])
  },

  update(message: PendingEditUpload) {
    return updateOne(COLLECTION)(message.id, { $set: message })
  },
}

export const pendingEditUploadsReducer = dbReducer(['main', COLLECTION])
